var path = '/home/jenkins/workspace/arcade_Arcade-UI_release/app/views/claims-and-accounts/claims/all-claims-container.html';
var html = "<all-claims show-for-lob=\"E&I\"></all-claims>\n<react-all-claims show-for-lob=\"M&R\"></react-all-claims>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;